import * as React from "react";
import {veboxDefaultTheme} from "../../index";
import {ThemeProvider} from "@vebox/etui-system";

export class GlobalSettings extends React.Component<any, any> {
    public render() {
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
            <div className={"GlobalSettings"} style={{width: "100%", height: "100%", position: "relative"}}>
                <h1
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "black",
                    }}
                >
                    Global Settings
                </h1>
            </div>
            </ThemeProvider>
        );
    }
}
